import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MOSCOW_TIME_ZONE_LABEL } from '@shared/functions/moscow-date-time.function';

@Component({
  selector: 'app-moscow-time-zone-badge',
  template: `{{ label }}`,
  styleUrl: './moscow-time-zone-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    title: 'Московское время (UTC+3)',
    'aria-label': 'Московское время, UTC+3',
  },
})
export class MoscowTimeZoneBadgeComponent {
  protected readonly label = MOSCOW_TIME_ZONE_LABEL;
}
